export default __webpack_public_path__ + "static/8336-35e975d72812ad34df8c59e9846696eb.jpg";